import type { useGuidedModeStore } from '../stores/guidedMode'
import type { GuidedModeDefinition } from '../types/guided-mode.types'

interface PrepareGuidedWeightOnStopParams {
  definition: GuidedModeDefinition | null | undefined
  guidedModeStore: ReturnType<typeof useGuidedModeStore>
}

export function prepareGuidedWeightOnStop({
  definition,
  guidedModeStore,
}: PrepareGuidedWeightOnStopParams): string[] {
  const includedConceptIds: string[] = []
  const weightConceptId = Object.entries(definition?.concepts || {})
    .find(([, concept]) => concept.code?.code === 'weight')?.[0]
  if (weightConceptId) {
    const weight = guidedModeStore.effectiveAnswers[weightConceptId]
    if (weight === undefined || weight === null || String(weight).trim() === '') {
      guidedModeStore.setAnswers({
        ...guidedModeStore.effectiveAnswers, [weightConceptId]: 'unknown',
      })
    }
    // Weight may not belong to a focused plan the worker has started yet.
    includedConceptIds.push(weightConceptId)
  }
  return includedConceptIds
}
